module.exports = __webpack_public_path__ + "img/h_3.8cef8547.png";